import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { validateLicenseKey, saveLicense, PLAN_LABEL } from '../config/licenseKeys';
import { RyzenMark as RyzenStar } from '../components/RyzenLogo';
import './Activate.css';

export default function Activate() {
  const navigate = useNavigate();
  const [key, setKey] = useState('');
  const [error, setError] = useState('');
  const [ok, setOk] = useState(null); // { plan, seats }

  // Pre-fill the key when arriving from the welcome email link (/activate?key=...)
  useEffect(() => {
    const k = (new URLSearchParams(window.location.search).get('key') || '').trim().toUpperCase();
    if (k) {
      setKey(k);
      const res = validateLicenseKey(k);
      if (res.valid) setOk(res); else setError(res.error || '');
    }
  }, []);

  const check = () => {
    const res = validateLicenseKey(key);
    if (!res.valid) { setError(res.error); setOk(null); return; }
    setError('');
    setOk(res);
  };

  const activate = () => {
    const res = ok || validateLicenseKey(key);
    if (!res.valid) { setError(res.error); return; }
    saveLicense(res);
    localStorage.setItem('ryzenos_activating', 'true');
    // Fresh activation: wipe any previous tenant's cached profile so the
    // onboarding form always starts blank on this device. Only seed the
    // new company's name (never the old address/email/services/etc).
    ['ryzenos_company', 'ryzenos_company_profile', 'ryzenos_user_profile'].forEach(k => localStorage.removeItem(k));
    try { localStorage.setItem('ryzenos_company', JSON.stringify({ name: res.company || '' })); } catch {}
    navigate('/onboarding');
  };

  const seatText = (res) =>
    res.seats == null ? 'Unlimited team members' : `Up to ${res.seats} team member${res.seats > 1 ? 's' : ''}`;

  return (
    <div className="ac-wrap">
      <div className="ac-card">
        <div className="ac-card-bar" />
        <div className="ac-brand">
          <RyzenStar size={24} />
          <span className="ac-brand-name">RyzenOS</span>
        </div>

        <div className="ac-title">Activate your workspace</div>
        <div className="ac-sub">Enter the license key we sent you to set up your account.</div>

        <label className="ac-lbl">License key</label>
        <input
          className="ac-inp"
          placeholder="RYZ-XXXXX-XXXXX"
          value={key}
          autoFocus
          onChange={(e) => { setKey(e.target.value.toUpperCase()); setError(''); setOk(null); }}
          onKeyDown={(e) => e.key === 'Enter' && (ok ? activate() : check())}
        />
        {error && <div className="ac-error">{error}</div>}

        {ok && (
          <div className="ac-ok">
            <div className="ac-ok-plan">{PLAN_LABEL[ok.plan]} plan</div>
            <div className="ac-ok-seats">{seatText(ok)}</div>
          </div>
        )}

        {ok ? (
          <button className="ac-btn" onClick={activate}>Continue to setup</button>
        ) : (
          <button className="ac-btn" onClick={check}>Verify key</button>
        )}

        <div className="ac-alt">
          Already have an account? <span onClick={() => navigate('/login')}>Sign in</span>
        </div>
      </div>
      <div className="ac-footer">Powered by Ryzenforge Enterprises LLP</div>
    </div>
  );
}
